import MainView from '../views/MainView'

const routes = [
    {
        path: '/',
        name: 'home',
        component: MainView,
        title: 'Home',
        icon: 'home',
    },
    {
        path: '/designtests',
        name: 'designtests',
        component: MainView,
        title: 'Designtests',
        icon: 'remove_red_eye',
        group: 'Tests',
    },
    {
        path: '/roleperms',
        name: 'roleperms',
        component: MainView,
        title: 'RolePermissions',
        icon: 'assignment',
        group: 'Administration',
    },
    {
        path: '/configs',
        name: 'configs',
        component: MainView,
        title: 'Configs',
        icon: 'assignment',
        group: 'Administration',
    },
    {
        path: '/cfgtables',
        name: 'cfgtables',
        component: MainView,
        title: 'CfgTables',
        icon: 'assignment',
        group: 'Administration',
    },
    {
        path: '/cfgmenus',
        name: 'cfgmenus',
        component: MainView,
        title: 'CfgMenus',
        icon: 'assignment',
        group: 'Administration',
    },
    {
        path: '/cfgactions',
        name: 'cfgactions',
        component: MainView,
        title: 'CfgActions',
        icon: 'assignment',
        group: 'Administration',
    },
    {
        path: '/cfgreftables',
        name: 'cfgreftables',
        component: MainView,
        title: 'CfgRefTables',
        icon: 'assignment',
        group: 'Administration',
    },
    {
        path: '/users',
        name: 'users',
        component: MainView,
        title: 'Benutzer',
        icon: 'account_circle',
        group: 'Administration',
    },
    {
        path: '/roles',
        name: 'roles',
        component: MainView,
        title: 'Rollen',
        icon: 'assignment_ind',
        group: 'Administration',
    },
    {
        path: '/teams',
        name: 'teams',
        component: MainView,
        title: 'Teams',
        icon: 'supervised_user_circle',
        group: 'Administration',
    },
    {
        path: '*',
        name: 'undefined',
        redirect: '/',
    },
]
export default routes;
  